import React from "react"
import { useSelector, useDispatch } from "react-redux"

import Images from "assets/images"
import { MtAccount } from "server/models"
import {
    StoreType,
    setNotAssignedUserAccountSelected,
} from "client/store"
import {
    Logo,
    Expired,
    TableColumn,
} from "client/components"

const Columns = () => {
    const selected = useSelector((state: StoreType) => state.accountUser.notAssignedAccounts.selected)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const selectAccount = (account: MtAccount) => { // only 1 account can be selected
        let newSelected: number[]
        if (selected && selected[0] === account.id) {
            newSelected = []
        } else {
            newSelected = [account.id]
        }
        dispatch(setNotAssignedUserAccountSelected(newSelected))
    }

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
            onClick: selectAccount,
        },
        {
            field: "logo",
            header: lang.logo,
            centerAlign: true,
            formatter: (account: MtAccount) => <Logo table logo={account.logo || Images.accountLogo} />,
            onClick: selectAccount,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
            onClick: selectAccount,
            formatter: (account: MtAccount) => {
                let demo = null
                if (account.demoExpiry !== null) {
                    const expiryDate = new Date(account.demoExpiry).getTime()
                    const now = new Date().getTime()
                    demo = ((expiryDate - now) < 0) ? lang.demoExpired : lang.demo
                }
                return (
                    <>
                        {account.shortName ? `${account.name} (${account.shortName})` : account.name}
                        {demo && <Expired>{demo}</Expired>}
                    </>
                )
            },
        },
        {
            field: "status",
            header: lang.status,
            centerAlign: true,
            sortable: true,
            editAccess: () => true, // only Super Admin can deactivate users
        },
    ]

    return columns
}
export default Columns
